export class ClsMenuDiaModel {
  public MD_ID:number;
  public MD_MENU_ID: number;
  public MD_DIA_NUMERO: number;
  public MD_DIA_NOMBRE:string;
  public MD_ESTADO: string;
  public MD_USU_ID: number;
  public MD_IP_EQUIPO: string; 
}
